var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { AllEntityTypeConfigurationConstants } from "../../../models/basics/basics.models";
import { activationStrategy } from "aurelia-router";
import { computedFrom } from "aurelia-binding";
import { UserClaimsService } from "../../../services/authentication/user-claims.service";
import { Reflection } from "../../../utilities/reflection";
import { CacheClient, CacheLocation } from "../../../services/basics/client-caching.service";
var Queries = /** @class */ (function () {
    function Queries(element, userClaimsService, cacheClient) {
        this.element = element;
        this.userClaimsService = userClaimsService;
        this.cacheClient = cacheClient;
        this.initialQueryId = -1;
        this.fixedColumns = [];
        this.fixedFilters = [];
        this.onColumnPushed = function (column) { };
        this.onColumnsPrepared = function (columns) { };
    }
    Queries.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    Queries.prototype.dispatchEvent = function (nameEvent, data) {
        if (this.element && nameEvent) {
            var customEvent = new CustomEvent(nameEvent, { bubbles: true, detail: data });
            this.element.dispatchEvent(customEvent);
        }
    };
    Object.defineProperty(Queries.prototype, "queryEditor", {
        get: function () {
            return this._queryEditor;
        },
        set: function (value) {
            this._queryEditor = value;
            if (value) {
                this.dispatchEvent("query-editor-available");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Queries.prototype, "allColumns", {
        get: function () {
            return this.queryEditor && this.queryEditor.columns && this.fixedColumns
                ? this.queryEditor.columns.concat(this.fixedColumns)
                : [];
        },
        enumerable: false,
        configurable: true
    });
    Queries.prototype.activate = function (params, navigationInstruction) {
        var _this = this;
        this.onRowSelected = navigationInstruction.onRowSelected;
        this.settings = navigationInstruction.settings;
        this.gridSettings = navigationInstruction.gridSettings;
        this.fixedFilters = navigationInstruction.fixedFilters ? navigationInstruction.fixedFilters(params) : [];
        this.queryHeaderViewModel = navigationInstruction.queryHeaderViewModel ? navigationInstruction.queryHeaderViewModel : null;
        this.fixedColumns = navigationInstruction.fixedColumns ? navigationInstruction.fixedColumns : [];
        this.onColumnPushed = navigationInstruction.onColumnPushed ? navigationInstruction.onColumnPushed : function (column) { };
        this.onColumnsPrepared = navigationInstruction.onColumnsPrepared ? navigationInstruction.onColumnsPrepared : function (columns) { };
        this.clickMode = navigationInstruction.clickMode ? navigationInstruction.clickMode : "double";
        this.getParams = navigationInstruction.getParams ? navigationInstruction.getParams : function (item) { return ({ id: item ? item.id : 0 }); };
        this.addRoute = navigationInstruction.createNewRoute ? (typeof navigationInstruction.createNewRoute == "string" ? navigationInstruction.createNewRoute : navigationInstruction.createNewRoute.name) : null;
        if (this.addRoute == null) {
            this.addRoute = navigationInstruction.addRoute ? (typeof navigationInstruction.addRoute == "string" ? navigationInstruction.addRoute : navigationInstruction.addRoute.name) : null;
        }
        this.editRoute = navigationInstruction.editRoute ? (typeof navigationInstruction.editRoute == "string" ? navigationInstruction.editRoute : navigationInstruction.editRoute.name) : null;
        this.uri = navigationInstruction.entity ? navigationInstruction.entity : navigationInstruction.route.split("/")[1];
        this.hasNavbar = navigationInstruction.hasNavbar;
        this.sortAlphabetically = 'sortAlphabetically' in navigationInstruction ? navigationInstruction.sortAlphabetically : true;
        this.enableUploadExcel = navigationInstruction.enableUploadExcel;
        var entityMeta = Enumerable.from(AllEntityTypeConfigurationConstants)
            .firstOrDefault(function (x) { return x.uri && x.uri.replace(/ /g, "").toLowerCase() == _this.uri.replace(/-/g, "").toLowerCase(); });
        if (navigationInstruction.claimsToAdd && this.userClaimsService.hasPermissions(navigationInstruction.claimsToAdd)) {
            this.addNewText = entityMeta ? entityMeta.typeSingular : "";
        }
        else {
            this.addNewText = null;
        }
        if (navigationInstruction.initialQueryId)
            this.initialQueryId = navigationInstruction.initialQueryId;
        else
            this.cacheClient.get('last_query_list_' + this.uri, CacheLocation.LocalStorage).then(function (x) {
                if (x) {
                    _this.initialQueryId = x;
                }
            }).catch();
        //DO NOT REMOVE BECAUSE IT IS NEEDED FOR WEBPACK
        if (!window["SystemJS"] && this.hasNavbar) {
            require("" + "./navbar/" + this.uri + "-navbar");
        }
    };
    Queries.prototype.onSavedQueryChanged = function ($event) {
        var queryId = $event.detail.queryId;
        this.cacheClient.put('last_query_list_' + this.uri, queryId);
    };
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.queryEditor; }), Reflection.getPropertyPath(function (x) { return x.queryEditor.columns; }), Reflection.getPropertyPath(function (x) { return x.fixedColumns; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Queries.prototype, "allColumns", null);
    Queries = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element, UserClaimsService, CacheClient])
    ], Queries);
    return Queries;
}());
export { Queries };
